import { Table, Pagination, Button, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"; // Added icon imports
import moment from "moment";

function DataTable(props) {
  const columns = [
    {
      title: "Date",
      dataIndex: "voucher_date",
      key: "voucher_date",
      render: (text) => <span>{moment(text).format("DD-MM-YYYY")}</span>,
    },
    {
      title: "Ledger From",
      dataIndex: "ledger_from",
      key: "ledger_from",
      render: (text, record) =>
        `${record.ledger_from} - ${record.fromAccount?.account_name || ""}`,
    },
    {
      title: "Ledger To",
      dataIndex: "ledger_to",
      key: "ledger_to",
      render: (text, record) =>
        `${record.ledger_to} - ${record.toAccount?.account_name || ""}`,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "",
      key: "action",
      render: (item) => (
        <div className="tableAction">
          <Button
            setLoading={props.loading}
            size="small"
            onClick={() => props.update(item)}
            icon={<EditOutlined />}
            style={{ marginRight: 10 }}
          ></Button>
          <Popconfirm
            placement="bottomRight"
            title={"Are you sure to delete?"}
            okText="Yes"
            cancelText="No"
            onConfirm={() => props.delete(item)}
          >
            <Button danger size="small" icon={<DeleteOutlined />}></Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div style={{ minHeight: "60vh" }}>
      <Table
        columns={columns}
        dataSource={props.data}
        pagination={false}
        size="small"
      />
      <br />
      <div align="right">
        <Pagination
          defaultCurrent={props.meta && props.meta.page}
          total={props.meta && props.meta.itemCount}
          pageSize={props.meta && props.meta.take ? props.meta.take : 0}
          onChange={props.PageOnchange}
          pageSizeOptions={[10, 20, 50]}
        />
      </div>
    </div>
  );
}

export default DataTable;
